import viewerMenuOverrideStyles from './viewer-menu-overrides.css?raw';
import { createReusableStylesheet } from '../reusable-stylesheet';

const viewerMenuOverridesReusableStylesheet = createReusableStylesheet(
  'trimble:viewer-menu-overrides',
  viewerMenuOverrideStyles
);

export { viewerMenuOverridesReusableStylesheet };
